const Breakpoints = {
  mobile: "599",
  tablet: "760",
  desktop: "1200",
}

export default Breakpoints
